import { axiosInstance as request } from '@/api/rest.service'

export const getTodos = (url, params = {}) => request.get(url, { params })
export const updateTodo = (id, payload) => request.put(`/to-dos/${id}`, payload)
export const deleteTodo = id => request.delete(`/to-dos/${id}`)
export const getStates = () => request.get('/to-dos/states')
export const getUsers = () => request.get('/users')
